module.exports = __webpack_public_path__ + "static/media/tractor-2.4f994184.jpg";